import type { NodeType } from '../types/project';
import type { GenerationProfile, ProductTypeConfig } from '../types/nodeConfig';

export function defaultProductType(name = 'Product A'): ProductTypeConfig {
  return {
    id: crypto.randomUUID(),
    name,
    shape: 'circle',
    color: '#ffcc00',
    size: 8,
    use_real_dimensions: false,
    length_cm: 0,
    width_cm: 0,
    percentage: 100,
    unit: 'kg',
    weight_kg: 1,
    enabled: true,
  };
}

export function defaultGenerationProfile(rate = 38): GenerationProfile {
  return { type: 'constant', rate };
}

export function typeSpecificDefaults(type: NodeType): Record<string, unknown> {
  switch (type) {
    case 'input':
      return {
        products_per_minute: 38,
        input_unit: 'kg/min',
        product_unit_label: '1 kg of product',
        generation_profile: defaultGenerationProfile(38),
        product_types: [defaultProductType('Grade-1')],
      };
    case 'splitter':
    case 'diverger':
      return {
        distribution_type: 'equal',
        weights: [],
        route_weights: [],
        routing_rules: [],
      };
    case 'gate':
      return {
        initial_state: 'open',
        open_route_index: 0,
        closed_route_index: 1,
        manual_control_enabled: true,
        schedule: [],
      };
    case 'merger':
      return {
        mode: 'fifo',
        queue_warning_threshold: 10,
      };
    case 'output':
      return {
        category: 'completed',
        expected_product_type_ids: [],
        target_throughput_per_minute: undefined,
      };
    case 'processor':
      return {
        capacity: 1,
        queue_warning_threshold: 5,
        runtime_congestion_warning_enabled: true,
        processor_rules: [],
      };
    case 'waypoint':
    default:
      return {};
  }
}
